/**
 * 账户模块相关路由
 */
import Layout from '@/views/layout/index.vue'
export default {
  path: '/datasource',
  component: Layout,
  redirect: '/datasource/meta',
  name: 'datasource',
  meta: { title: '数据源管理', icon: 'example' },
  children: [
    {
      path: '/mediaData/meta',
      name: 'meta',
      component: () => import('@/views/datasource/meta'),
      meta: {
        title: 'Meta', 
        icon: 'account', 
        breadcrumb: ['数据源管理', '媒体数据', 'Meta']
      }
    },
    {
      path: '/mediaData/google',
      name: 'google',
      component: () => import('@/views/datasource/google'),
      meta: {
        title: 'Google',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', 'Google']
      },
    },
    {
      path: '/mediaData/asa',
      name: 'asa',
      component: () => import('@/views/datasource/asa'),
      meta: {
        title: 'ASA',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', 'ASA']
      },
    },
    {
      path: '/mediaData/kwai',
      name: 'kwai',
      component: () => import('@/views/datasource/kwai'),
      meta: {
        title: 'Kwai',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', 'Kwai']
      },
    },
    {
      path: '/mediaData/oceanengine',
      name: 'oceanengine',
      component: () => import('@/views/datasource/oceanengine'),
      meta: {
        title: '巨量引擎',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', '巨量引擎']
      },
    },
    {
      path: '/mediaData/tiktok',
      name: 'tiktok',
      component: () => import('@/views/datasource/tiktok'),
      meta: { 
        title: 'TikTok',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', 'TikTok']
      },
    },
    {
      path: '/mediaData/qianchuan',
      name: 'qianchuan',
      component: () => import('@/views/datasource/qianchuan'),
      meta: {
        title: '巨量千川',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', '巨量千川']
      },
    },
    {
      path: '/mediaData/kuaishou',
      name: 'kuaishou',
      component: () => import('@/views/datasource/kuaishou'),
      meta: {
        title: '快手',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', '快手']
      },
    },
    {
      path: '/mediaData/bing',
      name: 'bing',
      component: () => import('@/views/datasource/bing'),
      meta: {
        title: 'Bing',
        icon: 'account',
        breadcrumb: ['数据源管理', '媒体数据', 'Bing']
      },
    },
    {
      path: '/thirdpartyData/appsflyer',
      name: 'appsflyer',
      component: () => import('@/views/datasource/appsflyer'),
      meta: {
        title: 'Appsflyer',
        icon: 'account',
        breadcrumb: ['数据源管理', '第三方数据', 'Appsflyer']
      },
    },
    {
      path: '/mixData/fbAndAf',
      name: 'fbAndAf',
      component: () => import('@/views/datasource/fbAndAf'),
      meta: {
        title: 'Meta+产品+AF',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Meta+产品+AF']
      },
    },
    {
      path: '/mixData/metaAndAfTrip',
      name: 'metaAndAfTrip',
      component: () => import('@/views/datasource/metaAndAfTrip'),
      meta: {
        title: 'Meta+AF-TRIP',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Meta+产品+AF']
      },
    },
    {
      path: '/mixData/ggAndAf',
      name: 'ggAndAf',
      component: () => import('@/views/datasource/ggAndAf'),
      meta: {
        title: 'Google+产品+AF',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Google+产品+AF']
      },
    },
    {
      path: '/mixData/ggAndAe',
      name: 'ggAndAe',
      component: () => import('@/views/datasource/ggAndAe'),
      meta: {
        title: 'Google+AE-APP',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Google+AE-APP']
      },
    },
    {
      path: '/mixData/ggAndAePc',
      name: 'ggAndAePc',
      component: () => import('@/views/datasource/ggAndAePc'),
      meta: {
        title: 'Google+AE-PC',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Google+AE-PC']
      },
    },
    {
      path: '/mixData/ttAndAe',
      name: 'ttAndAe',
      component: () => import('@/views/datasource/ttAndAe'),
      meta: {
        title: 'TikTok+AE',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'TikTok+AE']
      },
    },
    {
      path: '/mixData/metaAndAe',
      name: 'metaAndAe',
      component: () => import('@/views/datasource/metaAndAe'),
      meta: {
        title: 'Meta+AE',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Meta+AE']
      },
    },
    {
      path: '/mixData/ggAndIcbu',
      name: 'ggAndIcbu',
      component: () => import('@/views/datasource/ggAndIcbu'),
      meta: {
        title: 'Google+ICBU',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Google+ICBU']
      },
    },
    {
      path: '/mixData/ggAndIcbuAndAsset',
      name: 'ggAndIcbuAndAsset',
      component: () => import('@/views/datasource/ggAndIcbuAndAsset'),
      meta: {
        title: 'Google-ICBU-素材',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Google-ICBU-素材']
      },
    },
    {
      path: '/mixData/fbAndIcbu',
      name: 'fbAndIcbu',
      component: () => import('@/views/datasource/fbAndIcbu'),
      meta: {
        title: 'Meta+ICBU',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Meta+ICBU']
      },
    },
    {
      path: '/mixData/ttAndIcbu',
      name: 'ttAndIcbu',
      component: () => import('@/views/datasource/ttAndIcbu'),
      meta: {
        title: 'TikTok+ICBU',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'TikTok+ICBU']
      },
    },
    {
      path: '/mixData/multiMedia',
      name: 'multiMedia',
      component: () => import('@/views/datasource/multiMedia'),
      meta: {
        title: 'ICBU-FB+GG',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'ICBU-FB+GG']
      },
    },
    {
      path: '/mixData/metaAdjustOrderTrip',
      name: 'metaAdjustOrderTrip',
      component: () => import('@/views/datasource/metaAdjustOrderTrip'),
      meta: {
        title: 'Meta+adjust+order-trip',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Meta+adjust+order-trip']
      },
    },
    {
      path: '/mixData/snapchatAndAe',
      name: 'snapchatAndAe',
      component: () => import('@/views/datasource/snapchatAndAe'),
      meta: {
        title: 'Snapchat-AE',
        icon: 'account',
        breadcrumb: ['数据源管理', '混合数据', 'Snapchat-AE']
      },
    },
  ],
}
